"use strict";

export var FormConstants = {
  FORM_INITIALIZE: 'FORM_INITIALIZE',
  NAVIGATE_TO_PARENT: 'NAVIGATE_TO_PARENT',
  FORM_SUBMIT: 'FORM_SUBMIT',
  FORM_DESTROYED: 'FORM_DESTROYED',
  FORM_FOCUS_TABLE: 'FORM_FOCUS_TABLE'
};